export const environment = {
    production: true,
    usersApi: ' https://edelegateqaecs.unmeetings.org',
    countriesApi: ' https://edelegateqaecs.unmeetings.org',
    announcementsApi: 'https://edelegateqaecs.unmeetings.org',
    committeeplaceApi: 'https://edelegateqaecs.unmeetings.org',
    listOfMeetingsApi: 'https://edelegateqaecs.unmeetings.org',
    eDecisionsApi: 'https://edelegateqaecs.unmeetings.org',
    meetingsApi: 'https://edelegateqaecs.unmeetings.org',
    inscriptionMeetingsApi: 'https://edelegateqaecs.unmeetings.org',
    eListOfSpeakersApi: 'https://edelegateqaecs.unmeetings.org',
    lookupsApi: 'https://edelegateqaecs.unmeetings.org',
    eregistrationApi: 'https://edelegateqaecs.unmeetings.org',
    meetingsparticipantsApi: 'https://edelegateqaecs.unmeetings.org',
    delegatesApi: 'https://edelegateqaecs.unmeetings.org',
    securityCouncilApi: 'https://edelegatedevecs.unmeetings.org/securitycouncil',
    ecredentialsApi: 'https://edelegateqaecs.unmeetings.org',
    pDelegateApi: 'https://edelegateqaecs.unmeetings.org',
    eSpeakersApi: 'https://edelegateqaecs.unmeetings.org',
    dataUrl:'https://qat.bluebook.unmeetings.org/data.json',
    env:'QAT',

    region: 'us-east-1',
    identityPoolId: '',
    userPoolId: 'us-east-1_DHnIIqnA9',
    provider: 'UniteIDProd',
    clientId: '5d4uqdpgtub4bs7lvq7qqfprpj',
    espeakersURL: 'https://edelegateqa.unmeetings.org',
    callbackURL: 'https://edelegateqa.unmeetings.org',
    signoutURL: 'https://edelegateqa.unmeetings.org',
    appWebDomain: 'edelegateqa.auth.us-east-1.amazoncognito.com',
    rekognitionBucket: 'rekognition-pics',
    albumName: 'usercontent',
    bucketRegion: 'us-east-1',
    ddbTableName: 'LoginTrail',
    cognito_idp_endpoint: '',
    cognito_identity_endpoint: '',
    sts_endpoint: '',
    dynamodb_endpoint: '',
    s3_endpoint: '',
    // version
    version: '2019.11.06'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts